import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Card, CardContent, Grid} from "@mui/material";
import {WMSContext} from "../../../context/WMSContext";
import {
    getWmsItemsForPacking,
    packShipmentItem
} from "../../../../../api/wms/wmsItems/wmsItems";
import SearchBar from "../../../../../components/List/components/SearchBar";
import ToggleNavigation from "../../../../../components/WMS/Mobile/Toggle/ToggleNavigation";
import Toggle from "../../../../../components/WMS/Mobile/Toggle/Toggle";
import {FormattedMessage} from "react-intl";
import WmsItemWithOrder from "../../../../../components/WMS/Mobile/WmsItemWithOrder";
import ShipmentMultiPacking from "./components/Drawers/ShipmentMultiPackingDrawer";
import ShipmentMonoPacking from "./components/Drawers/ShipmentMonoPackingDrawer";
import ScanWorkstationModal from "../Modals/ScanWorkstationModal";
import WeighShipmentModal from "../Modals/WeighShipmentModal";
import ScanShippingZoneOrTrolleyModal from "../Modals/ScanShippingZoneOrTrolleyModal";
import AlreadyAssignedWorkstation from "../Modals/AlreadyAssignedWorkstartion";
import ClickAndCollectPackingModal from "../Modals/ClickAndCollectPackingModal";
import OffChartModal from "../Modals/OffChartModal";
import {BarCodeScannerContext} from "../../../../../contexts/barCodeScannerContext";
import {patchWMSContainerMemberWithCodebar} from "../../../../../api/wms/wmsContainers/wmsContainers";
import {packingStepNames} from "./packingSteps";
import DropZoneOrTrolleyDrawer from "./components/Drawers/DropZoneOrTrolleyDrawer";
import ship from "../../../../../api/shipment/ship";
import {ShippingMethods, ShippingMethodsDiscr} from "../../../../../utils/ShippingMethods";
import {
    resetCurrentPacking,
    shipmentPacked,
    assignShipmentToContainer
} from "../../../../../api/wms/shipment/shipment";
import PackingToast from "../PackingToast";
import {WmsItemsStatus} from "../../../../../utils/WmsItemsStatus";
import {launchOmniScan} from "../../../../../api/wms/omiScan";
import {WMSOmniScanReturnType} from "../../../../../utils/WMSOmniScanReturnType";
import {WmsContainerType} from "../../../../../utils/WMSContainerType";
import moment from "moment";
import {getTranslation} from "../../../../../domain/helpers/translations";
import SpecialOrderDrawer from "./components/Drawers/SpecialOrder";
import {KNCarrierType} from "../../../../../utils/KuehneNagelCarrierType";
import CustomButton from "../../../../../components/CustomButton";
import {red500} from "../../../../../assets/jss/main";
import PrinterConfigurationDrawer from "./components/Drawers/PrinterConfigurationDrawer";
import {specialOrderShipmentIsPackInWMS} from "../../../../../api/shipment/packing";
import AlreadyInPackingModal from "../Modals/AlreadyInPackingModal";
import {LineItemStatus} from "../../../../../utils/LineItemStatus";
import PackingActionButton from "./components/PackingActionButton";
import PackingActionDrawer from "./components/Drawers/PackingActionDrawer";
import {PackingContext} from "./PackingContext";
import {list} from 'api/cancellationReason/list'

function PackingOrderList() {
    const {currentInventory, currentOrganization, currentMember, preferredPrinter, preferredPackingStation, setPreferredPackingStation, isMobile} = useContext(WMSContext)
    const {scannedString, resetScannedString, setEnableScan} = useContext(BarCodeScannerContext)

    const [packingStep, setPackingStep] = useState({
        selectedShipment: {},
        stepName: packingStepNames.PEEK,
    })

    const [openProductProblemDrawer, setOpenProductProblemDrawer] = useState({
        isOpen: false,
        product: null,
        handleProductCancelled: () => {}
    })

    const [searchString, setSearchString] = useState("")
    const [loading, setLoading] = useState(false)
    const [selectedOrScannedContainer, setSelectedOrScannedContainer] = useState()

    const [currentWorkstation, setCurrentWorkstation] = useState()
    const [packingStationComputerId, setPackingStationComputerId] = useState()
    const [alreadyTakenPackingStationContainer, setAlreadyTakenPackingStationContainer] = useState()
    const [reservedOrders, setReservedOrders] = useState([])
    const [noPrinter, setNoPrinter] = useState(false)
    const [cancellationReasons, setCancellationReasons] = useState([]);
    const [packingLoading, setPackingLoading] = useState(false)

    // DRAWERS
    const [openShipmentMultiDrawer, setOpenShipmentMultiDrawer] = useState(false)
    const [openShipmentMonoDrawer, setOpenShipmentMonoDrawer] = useState(false)
    const [openDropZoneOrTrolleyDrawer, setOpenDropZoneOrTrolleyDrawer] = useState(false)
    const [openSpecialOrderDrawer, setOpenSpecialOrderDrawer] = useState(false)
    const [openPrinterConfigurationDrawer, setOpenPrinterConfigurationDrawer] = useState(false)
    const [openPackingActionDrawer, setOpenPackingActionDrawer] = useState(false)

    // SHIPMENT
    const [ordersWithShipments, setOrdersWithShipments] = useState({})
    const [tempOrdersWithShipments, setTempOrdersWithShipments] = useState({})
    const [filteredOrdersWithShipments, setFilteredOrdersWithShipments] = useState({})
    const [monoShipmentCount, setMonoShipmentCount] = useState(0)
    const [multiShipmentCount, setMultiShipmentCount] = useState(0)
    const [shipmentTypeIndex, setShipmentTypeIndex] = useState(0)
    const [shipmentWeigh, setShipmentWeigh] = useState(0)
    const [isCurrentShipmentReprint, setIsCurrentShipmentReprint] = useState(false)

    // TOAST
    const [openToast, setOpenToast] = useState(false)
    const [toastType, setToastType] = useState()
    const [toastIsTop, setToastIsTop] = useState(false)

    // MODALS
    const [openBeginPackingModal, setOpenBeginPackingModal] = useState(false)
    const [openScanWorkstationModal, setOpenScanWorkstationModal] = useState(false)
    const [openWeighShipmentModal, setOpenWeighShipmentModal] = useState(false)
    const [openScanShippingZoneOrTrolleyModal, setOpenScanShippingZoneOrTrolleyModal] = useState(false)
    const [openAlreadyAssignedWorkstationModal, setOpenAlreadyAssignedWorkstationModal] = useState(false)
    const [openClickAndCollectPackingModal, setOpenClickAndCollectPackingModal] = useState(false)
    const [openOffChartModal, setOpenOffChartModal] = useState(false)
    const [openAlreadyInPackingModal, setOpenAlreadyInPackingModal] = useState(false)

    const handlePackingStart = () => {
        getWmsItemsForPacking(currentInventory).then((response) => {
            let ordersAndShipments = {}
            for (let item of response) {
                const tempOrder = item.lineItem.currentShipment.order
                const tempShipment = item.lineItem.currentShipment
                const formattedShipment = getFormattedShipment(item, tempOrder, tempShipment)
                const formattedItem = getFormattedItem(item)

                if (!ordersAndShipments[tempOrder.id]) {
                    ordersAndShipments[tempOrder.id] = {}
                    ordersAndShipments[tempOrder.id].createdAt = moment(tempOrder.createdAt).format('x')
                }

                if (!ordersAndShipments[tempOrder.id].shipments) {
                    ordersAndShipments[tempOrder.id].shipments = []
                    ordersAndShipments[tempOrder.id].shipments[tempShipment.id] = formattedShipment
                }

                if (!ordersAndShipments[tempOrder.id].shipments[tempShipment.id]) {
                    ordersAndShipments[tempOrder.id].shipments[tempShipment.id] = formattedShipment
                }

                if (!ordersAndShipments[tempOrder.id].shipments[tempShipment.id].lineItems.includes(formattedItem)) {
                    ordersAndShipments[tempOrder.id].shipments[tempShipment.id].lineItems.push(formattedItem)
                    if (ordersAndShipments[tempOrder.id].shipments[tempShipment.id].lineItems.length > 1) {
                        ordersAndShipments[tempOrder.id].shipments[tempShipment.id].isMulti = true
                    }
                }
            }
            handleMonoAndMultiCount(ordersAndShipments)
            setTempOrdersWithShipments(ordersAndShipments)
            setOrdersWithShipments(ordersAndShipments)
        })
    }

    const getFormattedShipment = (item, order, shipment) => {
        let shipmentObject = {
            orderNumber: currentOrganization?.showDisplayExternalId && order.displayExternalId ? order.displayExternalId : order.externalId,
            externalDeliveryNumber: shipment.externalDeliveryNumber,
            orderId: order.id,
            shipmentId: shipment.id,
            shippingMethod: shipment.shippingMethod,
            isMulti: false,
            trackingNumber: shipment.trackingNumber,
            lineItems: [],
            createdAt: shipment.createdAt,
            container: shipment.container
        }

        if (shipment.shippingMethod.ccPointCode && shipment.shippingMethod.ccPointCode !== currentInventory.code) {
            shipmentObject = {...shipmentObject, isCCInternalWMSShip: true}
        }

        return shipmentObject;
    }

    const getFormattedItem = (item) => {
        const retailerTranslation = getTranslation(item.lineItem.retailer)
        return {
            id: item.lineItem.id,
            name: item.lineItem.name,
            pictures: item.lineItem.pictures,
            retailerName: item.lineItem.retailer.name,
            retailerIcon: retailerTranslation.logo?.contentUrl,
            ugCode: item.lineItem.variationSku,
            eanCode: item.barcode,
            options: item.lineItem.options,
            totalItem: 0,
            itemsScanned: 0,
            itemsCancelled: 0,
            isCancelled: false,
            isPacked: false,
            weight: item.lineItem.variation?.weight,
            currentShipment: item.lineItem.currentShipment,
            wmsItem: {
                id: item.id,
                status: item.status,
                currentContainer: item.wmsContainer,
                lineItem: item.lineItem,
                places: item.places,
                barcode: item.barcode
            }
        }
    }

    const handleMonoAndMultiCount = (ordersAndShipments) => {
        let tempMonoShipmentCount = 0
        let tempMultiShipmentCount = 0
        Object.keys(ordersAndShipments).map((orderId) => {
            Object.keys(ordersAndShipments[orderId].shipments).map((shipmentId) => {
                if (ordersAndShipments[orderId].shipments[shipmentId].isMulti) {
                    tempMultiShipmentCount++
                } else {
                    tempMonoShipmentCount++
                }
            })
        })
        setMonoShipmentCount(tempMonoShipmentCount)
        setMultiShipmentCount(tempMultiShipmentCount)
    }

    const handleFIFOSort = (orders) => {
        const sortedOrdersKeys = Object.keys(orders).sort((a, b) => Number(orders[a].createdAt) - Number(orders[b].createdAt));

        let sortedOrders = {};
        sortedOrdersKeys.forEach((item) => {
            sortedOrders[item] = orders[item];
        });

        return sortedOrders
    }

    const createOrdersAndShipmentObjectProperties = (ordersAndShipment, orderId, shipmentId) => {
        if (!ordersAndShipment[orderId]) {
            ordersAndShipment[orderId] = {
                shipments: [],
                createdAt: ordersWithShipments[orderId].createdAt
            }
        }

        if (!ordersAndShipment[orderId].shipments[shipmentId]) {
            ordersAndShipment[orderId].shipments[shipmentId] = {}
        }

        return ordersAndShipment
    }

    const handleFilterShipmentType = (value) => {
        setShipmentTypeIndex(value)
        let orderAndShipments = {}
        Object.keys(tempOrdersWithShipments).map((orderId) => {
            Object.keys(tempOrdersWithShipments[orderId].shipments).map((shipmentId) => {
                switch (value) {
                    case 0:
                        orderAndShipments = createOrdersAndShipmentObjectProperties(orderAndShipments, orderId, shipmentId)
                        orderAndShipments[orderId].shipments[shipmentId] = tempOrdersWithShipments[orderId].shipments[shipmentId]
                        break;
                    case 1:
                        if (!ordersWithShipments[orderId].shipments[shipmentId].isMulti) {
                            orderAndShipments = createOrdersAndShipmentObjectProperties(orderAndShipments, orderId, shipmentId)
                            orderAndShipments[orderId].shipments[shipmentId] = tempOrdersWithShipments[orderId].shipments[shipmentId]
                        }
                        break;
                    case 2:
                        if (ordersWithShipments[orderId].shipments[shipmentId].isMulti) {
                            orderAndShipments = createOrdersAndShipmentObjectProperties(orderAndShipments, orderId, shipmentId)
                            orderAndShipments[orderId].shipments[shipmentId] = tempOrdersWithShipments[orderId].shipments[shipmentId]
                        }
                        break;
                    default:
                        return
                }
            })
        })
        orderAndShipments = handleFIFOSort(orderAndShipments)
        setFilteredOrdersWithShipments(orderAndShipments)
    }

    const handleShipmentContainers = (shipment) => {
        let containers = []

        shipment.lineItems.map((item) => {
            if (containers.length === 0 || !containers.some(container => container.id === item.wmsItem.currentContainer.id)) {
                containers.push(item.wmsItem.currentContainer)
            }
        })

        return containers
    }

    const handleClickOnItem = (item) => {
        if (!noPrinter) {
            setPackingStep({
                ...packingStep,
                selectedShipment: item
            })
        }
    }

    const handleOpenOffChartShipment = (container) => {
        setSelectedOrScannedContainer(container)
        setOpenOffChartModal(true)
    }

    const handleShipmentWaitForDrop = () => {
        finishPacking()
    }

    const handleOpenScanWorkstationModal = () => {
        if (!openAlreadyInPackingModal && handleIsPackedShipment()) {
            setOpenAlreadyInPackingModal(true)
            return
        }

        setPackingStep({
            ...packingStep,
            stepName: packingStepNames.SCAN_WORKSTATION
        })

        handleCloseAlreadyInPacking()
    }

    const handleCloseOffChartModal = () => {
        setOpenOffChartModal(false)
        setEnableScan(true)
    }

    const handleCloseAlreadyAssignedWorkstationModal = () => {
        resetScannedString()
        setOpenScanWorkstationModal(true)
        setOpenAlreadyAssignedWorkstationModal(false)
    }

    const handleCloseScanWorkstationModal = () => {
        setOpenScanWorkstationModal(false)
        if (openShipmentMultiDrawer) {
            handleCloseShipmentMultiPackingDrawer()
        } else if (openShipmentMonoDrawer) {
            handleCloseShipmentMonoPackingDrawer()
        }
        setPackingStep({
            selectedShipment: {},
            stepName: packingStepNames.PEEK
        })
    }

    const handleCloseWeighShipmentModal = () => {
        resetCurrentPacking(packingStep.selectedShipment.shipmentId).then(() => {
            setPackingStep({
                ...packingStep,
                stepName: packingStepNames.RENEW
            })
            setOpenWeighShipmentModal(false)
        })
    }

    const handleCloseCCPackingModal = () => {
        resetCurrentPacking(packingStep.selectedShipment.shipmentId).then(() => {
            setPackingStep({
                ...packingStep,
                stepName: packingStepNames.RENEW
            })
            setOpenClickAndCollectPackingModal(false)
        })
    }

    const handleCloseDropZoneOrTrolleyDrawer = () => {
        setOpenDropZoneOrTrolleyDrawer(false)
        setOpenScanShippingZoneOrTrolleyModal(true)
    }

    const handleCloseShipmentMultiPackingDrawer = () => {
        if (packingStep.stepName === packingStepNames.PACK_ITEMS) {
            resetCurrentPacking(packingStep.selectedShipment.shipmentId).then(() => {
                setPackingStep({
                    ...packingStep,
                    stepName: packingStepNames.RENEW
                })
            })
        }
        setOpenShipmentMultiDrawer(false)
    }

    const handleCloseShipmentMonoPackingDrawer = () => {
        setOpenShipmentMonoDrawer(false)
        if (packingStep.stepName === packingStepNames.PACK_ITEMS) {
            setPackingStep({
                ...packingStep,
                stepName: packingStepNames.RENEW
            })
        }
    }

    const handleCloseProductProblemDrawer = () => {
        setOpenProductProblemsDrawer(false)
    }

    const handleZoneOrTrolleySelection = (selectedObject) => {
        setOpenDropZoneOrTrolleyDrawer(false)
        setOpenScanShippingZoneOrTrolleyModal(false)
        assignShipmentToContainer(selectedObject.containerCodebar, packingStep.selectedShipment.shipmentId).then(() => {
            finishPacking()
        })
    }

    const handleShippingSlip = (reprint = false, isCC = false) => {
        // This ensures already packedShipment only trigger a reprint.
        if (isCurrentShipmentReprint) {
            reprint = isCurrentShipmentReprint
        }

        setLoading(true)

        let totalWeight = 0

        for (let item of packingStep.selectedShipment.lineItems) {
            totalWeight += item.weight
        }

        const toShipObject = {
            isWMSCall: true,
            reprint: reprint,
            weight: packingStep.selectedShipment.shippingMethod.shippingMethodShopName !== ShippingMethods.CLICK_COLLECT ? shipmentWeigh : totalWeight,
            preferredPrinter: preferredPrinter
        }

        const shipment = {
            id: packingStep.selectedShipment.shipmentId
        }

        ship(shipment, toShipObject).catch((error) => {
            handleToast("error")
        })
    }

    const handleSlipPrinted = () => {
        resetScannedString()
        handleToast("printSuccess")
        setPackingStep({
            ...packingStep,
            stepName: packingStepNames.DROP_SHIPMENT
        })
        setOpenWeighShipmentModal(false)
    }

    function updatePackingStepAfterItemPacked(packingStep, setPackingStep, itemIndex) {
        let tempShipment = {...packingStep.selectedShipment}
        tempShipment.lineItems[itemIndex].itemsScanned++
        tempShipment.lineItems[itemIndex].isPacked = true
        tempShipment.lineItems[itemIndex].wmsItem.status = WmsItemsStatus.PACKED
        setPackingStep({
            ...packingStep,
            selectedShipment: tempShipment
        })
    }

    const handlePackItem = (eanCode) => {
        const itemIndex = packingStep.selectedShipment.lineItems.findIndex(item =>
            item.eanCode === eanCode &&
            (
                item.wmsItem.status === WmsItemsStatus.PACKED ||
                item.wmsItem.status === WmsItemsStatus.PACKING ||
                item.wmsItem.status === WmsItemsStatus.READY_TO_BE_PACKED
            ) && !item.isPacked && !item.isCancelled
        )

        if (itemIndex >= 0) {
            setPackingLoading(true)
            const wmsItemId = packingStep.selectedShipment.lineItems[itemIndex].wmsItem.id
            packShipmentItem(wmsItemId).then(() => {
                updatePackingStepAfterItemPacked(packingStep, setPackingStep, itemIndex)
            }).finally(() => {
                setPackingLoading(false)
            })
        } else {
            setEnableScan(true)
            handleToast("wrongItemScanned")
        }
    }

    const handleAllItemAreCancelled = () => {
        handleToast("allCancelled")
        setPackingStep({
            ...packingStep,
            stepName: packingStepNames.RENEW
        })
    }

    const handleForceAssignWorkstation = () => {
        patchWMSContainerMemberWithCodebar(alreadyTakenPackingStationContainer.codebar, currentMember).then(() => {
            handleWorkstationClaimed(alreadyTakenPackingStationContainer, alreadyTakenPackingStationContainer.computerId)
        })
    }

    const handlePrintClickAndCollectDocuments = () => {
        handleShippingSlip(false, true)
    }

    const handleManuallySelectShippingZoneOrTolley = () => {
        setOpenDropZoneOrTrolleyDrawer(true)
        setOpenScanShippingZoneOrTrolleyModal(false)
        if (packingStep.selectedShipment.isMulti) {
            setOpenShipmentMultiDrawer(false)
        } else {
            setOpenShipmentMonoDrawer(false)
        }
    }

    const handleBeginShipmentWeigh = () => {
        if (!packingStep.selectedShipment.isMulti && !packingStep.selectedShipment.isSpecialOrder) {
            packShipmentItem(packingStep.selectedShipment.lineItems[0].wmsItem.id)
        }

        if (packingStep.selectedShipment.isSpecialOrder) {
            specialOrderShipmentIsPackInWMS(packingStep.selectedShipment.id).then(() => {
                packingStep.selectedShipment.isPackedInWMS = true
            })
        }

        setPackingStep({
            ...packingStep,
            stepName: packingStepNames.WEIGH_SHIPMENT
        })
    }

    const handleWorkstationClaimed = (workstation, computerId) => {
        setPackingStationComputerId(computerId)
        setCurrentWorkstation(workstation)
        setPreferredPackingStation(workstation)
        setOpenScanWorkstationModal(false)
        setOpenAlreadyAssignedWorkstationModal(false)

        if (packingStep.selectedShipment.isSpecialOrder === true) {
            handleBeginShipmentWeigh();
        } else if (packingStep.stepName === packingStepNames.SCAN_WORKSTATION){
            setPackingStep(
                {
                    ...packingStep,
                    stepName: packingStepNames.PACK_ITEMS
                }
            )
            handleToast("pack_item", !packingStep.selectedShipment.isMulti)
        } else if (packingStep.stepName === packingStepNames.PEEK) {
            handleToast("workstationScanned", false)
        }

        resetScannedString()
    }

    const handleAlreadyTakenWorkstation = (container) => {
        setAlreadyTakenPackingStationContainer(container)
        setOpenAlreadyAssignedWorkstationModal(true)
    }

    const handleToast = (type, isTop = false) => {
        setToastType(type)
        setOpenToast(true)
        setToastIsTop(isTop)
    }

    const handleClosePrinterConfigurationDrawer = () => {
        setOpenPrinterConfigurationDrawer(false)
        window.location.reload()
    }

    const handleClosePackingActionDrawer = () => {
        setOpenPackingActionDrawer(false)
    }

    const finishPacking = () => {
        shipmentPacked(packingStep.selectedShipment.shipmentId).then(() => {
            handleToast("articleDropSuccess")
            setPackingStep({
                ...packingStep,
                stepName: packingStepNames.RENEW
            })
        })
    }

    function formatShipmentFromSpecialOrderForPacking(order, shipmentIndex) {
        const shipment = order.shipments[shipmentIndex];

        shipment.isMulti = shipment.multi;
        shipment.shipmentId = shipment.id
        shipment.isSpecialOrder = true;
        shipment.orderId = order.id;

        if (shipment.shippingMethod.additionalData?.clickAndCollectPoint !== currentInventory.code) {
            shipment.isCCInternalWMSShip = true
        }

        return order.shipments[shipmentIndex];
    }

    const handleValidAlreadyInPacking = () => {
        handleOpenScanWorkstationModal()
    }

    const handleCloseAlreadyInPacking = () => {
        setOpenAlreadyInPackingModal(false)
    }

    const handleIsPackedShipment = (shipmentItem = null) => {
        const shipment = shipmentItem ?? packingStep.selectedShipment
        const lineItems = shipment.lineItems
        let wmsItems = []

        lineItems.forEach(item => {
            wmsItems.push(item.wmsItem)
        })

        // If shipment has a container, its status is ready_to_be_shipped and it is not a special order shipment.
        const isPackedShipment = !!shipment.container

        // If current shipment is in ready_to_be_shipped status we only need to reprint.
        if (null === shipmentItem && isPackedShipment) {
            setIsCurrentShipmentReprint(true)
        } else if (null === shipmentItem) {
            setIsCurrentShipmentReprint(false)
        }

        let areLineItemsToShip = lineItems.every(item => item.status === LineItemStatus.TO_SHIP)

        const areWmsItemsPacked = wmsItems.every(
            item =>
                item.status === WmsItemsStatus.PACKED ||
                item.status === WmsItemsStatus.PACKING
        )

        if (isPackedShipment || areLineItemsToShip || areWmsItemsPacked) {
            return true
        }

        return false
    }

    const handlePackingAction = (action = "") => {
        switch (action) {
            case "specialOrder":
                setOpenSpecialOrderDrawer(true)
                setOpenPackingActionDrawer(false)
                break;
            case "printer":
                setOpenPrinterConfigurationDrawer(true)
                setOpenPackingActionDrawer(false)
                break;
            case "packingStation":
                resetScannedString()
                setEnableScan(true)
                setOpenScanWorkstationModal(true)
                setOpenPackingActionDrawer(false)
                break;
            default:
                setOpenPackingActionDrawer(false)
                break;
        }
    }

    // -----------------------USE-EFFECT--------------------------

    useEffect(() => {
        switch (packingStep.stepName) {
            case packingStepNames.PEEK:
                setEnableScan(true)
                if (packingStep.selectedShipment && Object.keys(packingStep.selectedShipment).length > 0) {
                    if (packingStep.selectedShipment.isMulti && !openScanShippingZoneOrTrolleyModal) {
                        setOpenShipmentMultiDrawer(true)
                    } else {
                        setOpenShipmentMonoDrawer(true)
                    }
                } else if (packingStep.selectedShipment && Object.keys(packingStep.selectedShipment).length === 0 && currentInventory) {
                    handlePackingStart()
                }
                break;
            case packingStepNames.SCAN_WORKSTATION:
                resetScannedString()
                if (!currentOrganization?.forcePackingStationScan) {
                    if (currentWorkstation && packingStationComputerId) {
                        setOpenToast(true)
                        setToastType("noWorkstationScanBeginPacking")
                        if (packingStep.selectedShipment.isSpecialOrder === true) {
                            handleBeginShipmentWeigh();
                        } else {
                            setPackingStep({
                                ...packingStep,
                                stepName: packingStepNames.PACK_ITEMS
                            })
                            handleToast("pack_item", !packingStep.selectedShipment.isMulti)
                        }
                    } else {
                        setEnableScan(true)
                        setOpenScanWorkstationModal(true)
                    }
                } else {
                    setEnableScan(true)
                    setOpenScanWorkstationModal(true)
                }
                break;
            case packingStepNames.PACK_ITEMS:
                setEnableScan(true)
                setOpenScanWorkstationModal(false)
                setOpenAlreadyAssignedWorkstationModal(false)
                break;
            case packingStepNames.WEIGH_SHIPMENT:
                assignShipmentToContainer(currentWorkstation.codebar, packingStep.selectedShipment.shipmentId).then(() => {
                    const shippingMethod = packingStep.selectedShipment.shippingMethod;
                    if (shippingMethod.shippingMethodShopName === ShippingMethods.CLICK_COLLECT || shippingMethod.discr === ShippingMethodsDiscr.CLICK_COLLECT || (shippingMethod.discr === ShippingMethodsDiscr.KN && shippingMethod.shippingMethodShopName === KNCarrierType.NAVETTE)) {
                        setOpenClickAndCollectPackingModal(true)
                    } else {
                        setOpenWeighShipmentModal(true)
                    }
                })
                break;
            case packingStepNames.DROP_SHIPMENT:
                setEnableScan(true)
                setOpenWeighShipmentModal(false)
                setOpenClickAndCollectPackingModal(false)
                setOpenScanShippingZoneOrTrolleyModal(true)
                setLoading(false)
                break;
            case packingStepNames.RENEW:
                setSearchString(null)
                setOpenShipmentMonoDrawer(false)
                setOpenShipmentMultiDrawer(false)
                setOpenBeginPackingModal(false)
                setOpenScanWorkstationModal(false)
                setOpenScanShippingZoneOrTrolleyModal(false)
                setOpenAlreadyAssignedWorkstationModal(false)
                setOpenClickAndCollectPackingModal(false)
                setOpenOffChartModal(false)
                setOpenProductProblemDrawer({
                    ...openProductProblemDrawer,
                    isOpen: false
                })
                setShipmentWeigh(0)
                if (currentOrganization?.forcePackingStationScan) {
                    setPackingStationComputerId(null)
                    setCurrentWorkstation(null)
                    setPreferredPackingStation({})
                }
                setLoading(false)
                resetScannedString()
                setTempOrdersWithShipments({})
                setFilteredOrdersWithShipments(null)
                setIsCurrentShipmentReprint(false)
                setPackingStep({
                    stepName: packingStepNames.PEEK,
                    selectedShipment: {}
                })
                handlePackingStart()
                break;
            default:
                return
        }
    }, [packingStep]);

    useEffect(() => {
        // TODO: At fine we need to search for the multi shipment's wmsContainer's name too
        let searchedOrdersAndShipments = {}
        Object.keys(ordersWithShipments).map((orderId) => {
            Object.keys(ordersWithShipments[orderId].shipments).map((shipmentId) => {
                if (ordersWithShipments[orderId].shipments[shipmentId].orderNumber.includes(searchString)) {
                    searchedOrdersAndShipments = createOrdersAndShipmentObjectProperties(searchedOrdersAndShipments, orderId, shipmentId)
                    searchedOrdersAndShipments[orderId].shipments[shipmentId] = ordersWithShipments[orderId].shipments[shipmentId]
                }
            })
        })
        handleMonoAndMultiCount(searchedOrdersAndShipments)
        setTempOrdersWithShipments(searchedOrdersAndShipments)
    }, [searchString]);

    useEffect(() => {
        if(Object.keys(tempOrdersWithShipments).length > 0) {
            handleFilterShipmentType(shipmentTypeIndex)
        }
    }, [tempOrdersWithShipments])

    // Scan useEffect
    useEffect(() => {
        if (scannedString !== "" && (0 < Object.keys(ordersWithShipments).length && 0 < Object.keys(tempOrdersWithShipments).length)) {
            setEnableScan(false)
            if (
                packingStep.stepName === packingStepNames.PEEK &&
                !openScanShippingZoneOrTrolleyModal &&
                !openScanWorkstationModal &&
                !openWeighShipmentModal &&
                !openAlreadyAssignedWorkstationModal &&
                !openBeginPackingModal
            ) {
                launchOmniScan(scannedString, currentInventory.id, {
                    item: [
                        WmsItemsStatus.READY_TO_BE_PACKED,
                        WmsItemsStatus.PACKED
                    ],
                    container: [WmsContainerType.HIVE]
                }).then((response) => {
                    if (response.length > 1) {
                        // Multiple entities detected need modal to check which is needed
                        // TODO: WMS V2 Omniscan add a global modal to select witch entity was scanned
                    }

                    if (response.length === 1) {
                        if (response[0].entityType !== WMSOmniScanReturnType.PLACE && response[0].entityType !== WMSOmniScanReturnType.SHIPMENT) {
                            let shipment = {}

                            Object.keys(filteredOrdersWithShipments).map((ordersId) => {
                                Object.keys(filteredOrdersWithShipments[ordersId].shipments).map((tempShipmentId) => {
                                    if (
                                        response[0].entityType === WMSOmniScanReturnType.ITEM &&
                                        !openShipmentMultiDrawer &&
                                        filteredOrdersWithShipments[ordersId].shipments[tempShipmentId].lineItems.some((lineItem) => lineItem.wmsItem.id === response[0].id)
                                    ) {
                                        shipment = filteredOrdersWithShipments[ordersId].shipments[tempShipmentId]
                                    }

                                    if (
                                        response[0].entityType === WMSOmniScanReturnType.CONTAINER &&
                                        response[0].type === WmsContainerType.HIVE &&
                                        !openShipmentMonoDrawer &&
                                        filteredOrdersWithShipments[ordersId].shipments[tempShipmentId].isMulti &&
                                        filteredOrdersWithShipments[ordersId].shipments[tempShipmentId].lineItems.some((lineItem) => lineItem.wmsItem.currentContainer.id === response[0].id)
                                    ) {
                                        shipment = filteredOrdersWithShipments[ordersId].shipments[tempShipmentId]
                                    }
                                })
                            })

                            if (Object.keys(shipment).length > 0) {
                                setPackingStep({
                                    stepName: packingStepNames.SCAN_WORKSTATION,
                                    selectedShipment: shipment
                                })

                                if (shipment.isMulti) {
                                    setOpenShipmentMultiDrawer(true)
                                } else {
                                    setOpenShipmentMonoDrawer(true)
                                }
                            } else {
                                if (response[0].entityType === WMSOmniScanReturnType.CONTAINER) {
                                    handleToast("omniScanWrongContainer")
                                }

                                if (response[0].entityType === WMSOmniScanReturnType.ITEM) {
                                    handleToast("omniScanWrongItem")
                                }

                                setPackingStep({
                                    stepName: packingStepNames.PEEK,
                                })
                            }
                        }
                    }

                    if (response.length === 0) {
                        setPackingStep({
                                stepName: packingStepNames.PEEK
                        })
                        handleToast("omniScanNotFound")
                    }
                    resetScannedString()
                })
            }

            if (
                packingStep.selectedShipment &&
                packingStep.stepName === packingStepNames.PACK_ITEMS &&
                openShipmentMultiDrawer &&
                !openScanShippingZoneOrTrolleyModal &&
                !openScanWorkstationModal &&
                !openWeighShipmentModal &&
                !openAlreadyAssignedWorkstationModal &&
                !openBeginPackingModal
            ) {
                let lineItemsEanCodes = packingStep.selectedShipment.lineItems.map((lineItem) => {
                    return lineItem.eanCode
                })

                if (lineItemsEanCodes.includes(scannedString)) {
                    handlePackItem(scannedString)
                } else {
                    setEnableScan(true)
                    handleToast("wrongItemScanned")
                }
            }
        }
    }, [scannedString]);

    useEffect(() => {
        if (currentInventory) {
            handlePackingStart()
        }
    }, [currentInventory]);

    useEffect(() => {
        if (0 === Object.keys(preferredPrinter).length) {
            setNoPrinter(true)
            setEnableScan(false)
        } else {
            setNoPrinter(false)
            setEnableScan(true)
        }
    }, [preferredPrinter]);

    useEffect(() => {
        if (0 < Object.keys(preferredPackingStation).length) {
            setPackingStationComputerId(preferredPackingStation.computerId)
            setCurrentWorkstation(preferredPackingStation)
        }
    }, [preferredPackingStation]);

    useEffect(() => {
        list("status=reserved&transition=cancel").then(response => {
            setCancellationReasons(response)
        })
    }, []);

    return (
        <PackingContext.Provider value={{
            cancellationReasons,
            openProductProblemDrawer,
            setOpenProductProblemDrawer,
            handleAllItemAreCancelled,
            handlePackItem,
            packingLoading
        }}>
        <Grid container direction={"column"}>

            {/* All modals are here */}
            <>
                {/* Scan Workstation modal */}
                {openScanWorkstationModal && (
                    <ScanWorkstationModal
                        open={openScanWorkstationModal}
                        handleClose={handleCloseScanWorkstationModal}
                        handleWorkstationClaimed={handleWorkstationClaimed}
                        handleAlreadyTakenWorkstation={handleAlreadyTakenWorkstation}
                    />
                )}

                {openAlreadyInPackingModal && (
                    <AlreadyInPackingModal
                        open={openAlreadyInPackingModal}
                        handleClose={handleCloseAlreadyInPacking}
                        handleIsValid={handleValidAlreadyInPacking}
                    />
                )}

                {/* Already assigned workstation modal */}
                {openAlreadyAssignedWorkstationModal && alreadyTakenPackingStationContainer && (
                    <AlreadyAssignedWorkstation
                        open={openAlreadyAssignedWorkstationModal}
                        handleClose={handleCloseAlreadyAssignedWorkstationModal}
                        handleValid={handleForceAssignWorkstation}
                    />
                )}

                {/* Weigh shipment modal */}
                {openWeighShipmentModal && (
                    <WeighShipmentModal
                        open={openWeighShipmentModal}
                        handleClose={handleCloseWeighShipmentModal}
                        handleValidation={handleShippingSlip}
                        isLoading={loading}
                        setIsLoading={setLoading}
                        shipmentWeigh={shipmentWeigh}
                        setShipmentWeigh={setShipmentWeigh}
                        packingStationComputerId={packingStationComputerId}
                        handleToast={handleToast}
                        packingStep={packingStep}
                        validPrint={handleSlipPrinted}
                    />
                )}

                {/* Scan zone or trolley */}
                {openScanShippingZoneOrTrolleyModal && packingStep.selectedShipment && (
                    <ScanShippingZoneOrTrolleyModal
                        open={openScanShippingZoneOrTrolleyModal}
                        handleClose={handleShipmentWaitForDrop}
                        handleManualSelection={handleManuallySelectShippingZoneOrTolley}
                        handleSlipPrint={handleShippingSlip}
                        isLoading={loading}
                        packingStep={packingStep}
                        handleOffChartShipment={handleOpenOffChartShipment}
                        handleShipmentWaitForDrop={handleShipmentWaitForDrop}
                        finishPacking={finishPacking}
                        isCC={packingStep.selectedShipment.shippingMethod.discr === ShippingMethodsDiscr.CLICK_COLLECT || packingStep.selectedShipment.shippingMethod.shippingMethodShopName === KNCarrierType.NAVETTE}
                    />
                )}

                {/* Click and collect modal */}
                {openClickAndCollectPackingModal && (
                    <ClickAndCollectPackingModal
                        open={openClickAndCollectPackingModal}
                        handleClose={handleCloseCCPackingModal}
                        handlePrintDocuments={handlePrintClickAndCollectDocuments}
                        packingStep={packingStep}
                        isLoading={loading}
                        setIsLoading={setLoading}
                        validPrint={handleSlipPrinted}
                    />
                )}

                {/* Off chart article modal */}
                <OffChartModal
                    open={openOffChartModal}
                    handleClose={handleCloseOffChartModal}
                    selectedContainer={selectedOrScannedContainer}
                    finishPacking={finishPacking}
                    shipment={packingStep.selectedShipment}
                />
            </>

            {/* Drop zone or trolley manual selection bottom drawer */}
            {openDropZoneOrTrolleyDrawer && packingStep.selectedShipment && (
                <DropZoneOrTrolleyDrawer
                    open={openDropZoneOrTrolleyDrawer}
                    handleClose={handleCloseDropZoneOrTrolleyDrawer}
                    handleZoneOrTrolleySelection={handleZoneOrTrolleySelection}
                    currentShipment={packingStep.selectedShipment}
                    isCCInternalWMSShip={packingStep.selectedShipment.isCCInternalWMSShip}
                    isCC={packingStep.selectedShipment.shippingMethod.discr === ShippingMethodsDiscr.CLICK_COLLECT || packingStep.selectedShipment.shippingMethod.shippingMethodShopName === KNCarrierType.NAVETTE}
                />
            )}

            {openShipmentMultiDrawer === true && packingStep.selectedShipment && (packingStep.selectedShipment.isMulti === true) && (
                <ShipmentMultiPacking
                    open={openShipmentMultiDrawer}
                    handleClose={handleCloseShipmentMultiPackingDrawer}
                    beginPacking={handleOpenScanWorkstationModal}
                    packingStep={packingStep}
                    beginShipmentWeigh={handleBeginShipmentWeigh}
                    setPackingStep={setPackingStep}
                />
            )}

            {openShipmentMonoDrawer === true && packingStep.selectedShipment && (packingStep.selectedShipment.isMulti === false) && (
                <ShipmentMonoPacking
                    open={openShipmentMonoDrawer}
                    handleClose={handleCloseShipmentMonoPackingDrawer}
                    beginPacking={handleOpenScanWorkstationModal}
                    packingStep={packingStep}
                    beginShipmentWeigh={handleBeginShipmentWeigh}
                />
            )}

            {openSpecialOrderDrawer === true && (
                <SpecialOrderDrawer
                    isOpen={openSpecialOrderDrawer}
                    onClose={() => setOpenSpecialOrderDrawer(false)}
                    currentInventory={currentInventory}
                    onClickSelectedOrder={(selectedSpecialOrder, shipmentIndex) => {
                        setPackingStep({
                            selectedShipment: formatShipmentFromSpecialOrderForPacking(selectedSpecialOrder, shipmentIndex),
                            stepName: packingStepNames.SCAN_WORKSTATION,
                        })
                    }}
                />
            )}

            {openPrinterConfigurationDrawer && (
                <PrinterConfigurationDrawer
                    open={openPrinterConfigurationDrawer}
                    onClose={() => handleClosePrinterConfigurationDrawer()}
                />
            )}

            {openPackingActionDrawer && (
                <PackingActionDrawer
                    open={openPackingActionDrawer}
                    onClose={() => handleClosePackingActionDrawer()}
                    selectedAction={(action) => handlePackingAction(action)}
                />
            )}

            <PackingToast
                open={openToast}
                handleClose={() => setOpenToast(false)}
                type={toastType}
                isTop={toastIsTop}
            />

            <Card>
                <CardContent>
                    <Grid container direction={"column"} gap={"20px"}>
                        <ToggleNavigation
                            fullWidth={true}
                            value={shipmentTypeIndex}
                            onChange={(value) => handleFilterShipmentType(value)}
                            autoMargin
                        >
                            {/* Value is 0 and is for no filter */}
                            <Toggle
                                fullWidth={true}
                                label={<FormattedMessage id={"wms.packing.filterToggle.label.all"}/>}
                                count={monoShipmentCount + multiShipmentCount}
                                autoHeight
                            />

                            {/* Value is 1 and is for mono filter */}
                            <Toggle
                                fullWidth={true}
                                label={<FormattedMessage id={"wms.packing.filterToggle.label.mono"}/>}
                                count={monoShipmentCount}
                                autoHeight
                            />

                            {/* Value is 2 and is for multi filter */}
                            <Toggle
                                fullWidth={true}
                                label={<FormattedMessage id={"wms.packing.filterToggle.label.multi"}/>}
                                count={multiShipmentCount}
                                autoHeight
                            />
                        </ToggleNavigation>

                        {noPrinter && (
                            <Grid container direction={isMobile ? "column" : "row"}>
                                <span style={{margin: "8px", color: red500}}><FormattedMessage id={"wms.packing.noPrinter"}/> </span>
                                <CustomButton color={"red"} variant={'outlined'} onClick={() => setOpenPrinterConfigurationDrawer(true)} rounded><FormattedMessage id={"wms.packing.noPrinter.buttonLabel"}/></CustomButton>
                            </Grid>
                        )}

                        <Grid container direction={"row"} flexWrap={"nowrap"}>
                            <Grid item xs={12}>
                                {/* SearchBar search inside the filtered list */}
                                <SearchBar
                                    customPlaceholder={"wms.packing.searchBar.placeholder"}
                                    onChange={(value) => setSearchString(value)}
                                />
                            </Grid>

                            <PackingActionButton onClick={() => {setOpenPackingActionDrawer(true)}} customMargin={"8px"}/>
                        </Grid>

                    </Grid>
                </CardContent>
            </Card>

            <Card>
                <CardContent>
                    <Grid container direction={"column"}>
                        {filteredOrdersWithShipments && Object.keys(filteredOrdersWithShipments).map((orderId) => {
                            if (undefined === ordersWithShipments[orderId]) {
                                return
                            }
                            const shipmentsIdArray = Object.keys(ordersWithShipments[orderId].shipments)
                            const shipmentsNumber = shipmentsIdArray.length

                            return Object.keys(filteredOrdersWithShipments[orderId].shipments).map((shipmentId, index) => {
                                const shipment = filteredOrdersWithShipments[orderId].shipments[shipmentId]
                                const isMulti = shipment.lineItems.length > 1

                                let isPackedShipment = false

                                if (handleIsPackedShipment(shipment)) {
                                    isPackedShipment = true
                                }

                                return (
                                    <div onClick={() => handleClickOnItem(shipment)}>
                                        <WmsItemWithOrder
                                            key={shipmentId}
                                            thumbnailSource={isMulti ? '#' : shipment.lineItems[0].pictures[0]}
                                            thumbnailAlt={`${shipment.lineItems.name} thumbnail`}
                                            icon={shipment.shippingMethod.carrierIcon}
                                            iconAlt={`${shipment.shippingMethod.name} icon`}
                                            numOrder={`#${shipment.orderNumber}`}
                                            description={
                                                isMulti ?
                                                    <span>{shipment.lineItems.length} <FormattedMessage id={'wms.packing.articles'}/></span> :
                                                    <span>{shipment.lineItems[0].name}</span>
                                            }
                                            isMulti={isMulti}
                                            badges={handleShipmentContainers(shipment)}
                                            multiShipment={shipmentsNumber > 1}
                                            shipmentCount={<span>{index + 1}/{shipmentsNumber}</span>} // Dans le cas d'une commande multi avec plusieurs shipments.
                                            isPackedShipment={isPackedShipment}
                                        />
                                    </div>
                                )
                            })
                        })}
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
        </PackingContext.Provider>
    );
}

export default PackingOrderList;
